import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { data } from "../../../Data/data";
import BlackCard from "../../../Components/Card";
import Animation from "../../../animations/Animation";

const Factors = () => {
   return (
      <section className="pt80 pb80 mobPb5 mobPt50 mobMb10">
         <Container>
            <Row className="mb40 mobMb20">
               <Col lg={6} md={12} sm={12} xs={12}>
                  <Animation fade bottom>
                     <section className="about-section">
                        <span className="red-bar">WHY CHOOSE US</span>
                        <h2 className="fBold tabHeadingFontSize mobSubTitle">
                           Factors That Set <br /> Us Apart
                        </h2>
                     </section>
                  </Animation>
               </Col>

               <Col lg={6} md={12} sm={12} xs={12}>
                  <Animation fade bottom>
                     <div className="mobMt10 mt30">
                        <p>
                           We are a reliable, innovative, and promising IT staff augmentation company. Partner with us for a proven track record of success, as we consistently deliver high-quality
                           solutions that are on time and within your budget constraints.
                        </p>
                     </div>
                  </Animation>
               </Col>
            </Row>

            <Row className="">
               {data.factors.map((factor) => (
                  <Col sm={12} md={6} lg={4} xl={4} key={factor.id} className="p-3">
                     <Animation zoom>
                        <BlackCard //
                           data={factor}
                           height={"285px"}
                           image={factor.image}
                        />
                     </Animation>
                  </Col>
               ))}
            </Row>
         </Container>
      </section>
   );
};

export default Factors;
